/* Duskhaven homepage behaviour: room preview dialogs.
   Duskhaven 2.0 (2026-10-03): the hero no longer renders in a shadow root, so the old attach step is gone. */
(function () {
  if (window.__dhHomeInit) return;
  window.__dhHomeInit = true;

  function bindRooms(root) {
    (root || document).querySelectorAll('[data-dh-dialog]').forEach(function (button) {
      if (button.__dhBound) return;
      button.__dhBound = true;
      button.addEventListener('click', function () {
        var dialog = document.getElementById(button.getAttribute('data-dh-dialog'));
        if (!dialog || typeof dialog.showModal !== 'function') return;
        dialog.showModal();
        document.body.classList.add('dh-lock');
      });
    });
    (root || document).querySelectorAll('dialog.dh-dialog').forEach(function (dialog) {
      if (dialog.__dhBound) return;
      dialog.__dhBound = true;
      var close = dialog.querySelector('.dh-dialog-close');
      if (close) close.addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (e) {
        if (e.target !== dialog) return;
        var r = dialog.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close();
      });
      dialog.addEventListener('close', function () {
        if (!document.querySelector('dialog.dh-dialog[open]')) document.body.classList.remove('dh-lock');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bindRooms(document); });
  } else {
    bindRooms(document);
  }
  document.addEventListener('shopify:section:load', function (e) { bindRooms(e.target); });
})();
